import { once } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { CommentContent } from '@hotjar/comments/components/CommentContent';
import { ZINDEX } from '@hotjar/webapp/components/GenericModal';
import { celebrate } from '@hotjar/webapp/utils/confetti';
import { tokens } from '@hotjar/hotsauce';

import { getAutoCreatedComment } from './getAutoCreatedComment';

const fireworks = once(() => celebrate({ zIndex: ZINDEX + 1 }));

const StyledCommentContent = styled(CommentContent)`
  background: white;
  margin-bottom: ${tokens.spacer.x1};
  ${tokens.elevation(1)};
`;

export interface AutoCreatedCommentProps {
  highlightCreatedAt?: Date;
}

export const AutoCreatedComment = ({
  highlightCreatedAt,
}: AutoCreatedCommentProps): JSX.Element => {
  const { t } = useTranslation();
  const autoCreatedComment = getAutoCreatedComment(t, highlightCreatedAt);

  return (
    <div onFocus={fireworks} onMouseOver={fireworks}>
      <StyledCommentContent
        currentUserId={0}
        onClose={undefined}
        onShowMoreMenu={undefined}
        comment={autoCreatedComment}
        renderCreator={() => null}
      />
    </div>
  );
};
